import styled from 'styled-components';
import BaseTable from '@src/components/common/Table';

export const ViewerWidgetWrapper = styled.div`
  background-color: #fff;
  margin: 5px;
  box-sizing: border-box;
  padding: 5px 0;
  min-height: 600px;
  height: 100%;
`;

export const TableWrapper = styled.div`
  min-height: 600px;
  margin: 5px;
  height: 100%;
  position: relative;
  background-color: #fff;
`;

export const StyledBaseTable = styled(BaseTable)`
  .BaseTable__row.selected {
    background-color: #d3e6f9;
  }

  .BaseTable__header,
  .BaseTable__header-row {
    background: transparent;
  }

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const BarIntervalText = styled.div`
  color: #6e6e6e;
  font-size: 0.9em;
  line-height: 2;
  padding: 4px 8px;
  background-color: #f2f2f2;
  border-radius: 6px;
`;

export const IconWrapper = styled.div`
  display: inline-block;
  padding: 0 2px;
`;
